// extracted by mini-css-extract-plugin
export var dataCell = "_n8-2";
export var dataRow = "_n8-0";
export var headerRow = "_n8-1";